module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C764"
  }, [_c('strong', [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_vm._v("Prefatory Note")])])]), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_c('p', {
    staticClass: "P51"
  }, [_vm._v("This volume contains revised versions of the papers presented at the Conference on Research in Income and Wealth titled “Measuring and Understanding the Distribution and Intra/Inter-Generational Mobility of Income and Wealth,” held in Bethesda, Maryland, on March 5–6, 2020.")]), _vm._v(" "), _c('p', {
    staticClass: "P4"
  }, [_vm._v("We gratefully acknowledge the financial support for this conference provided by the Stone Center on Socio-Economic Inequality at the CUNY Graduate Center, the Stone Wealth and Income Inequality Project at Brown University, Statistics of Income (SOI)/Internal Revenue Service (SOI), Opportunity Insights, and the NBER. Support for the general activities of the Conference on Research in Income and Wealth is provided by the following agencies: Bureau of Economic Analysis, Bureau of Labor Statistics, the Census Bureau, the Board of Governors of the Federal Reserve System, SOI/IRS, and Statistics Canada.")]), _vm._v(" "), _c('p', {
    staticClass: "C813"
  }, [_vm._v("We thank Raj Chetty, John N. Friedman, Janet C. Gornick, Barry Johnson, and Arthur Kennickell, who served as conference organizers and as editors of the volume.")]), _vm._v(" "), _c('p', {
    staticClass: "C816"
  }, [_vm._v("Executive Committee, November 2020")]), _vm._v(" "), _c('p', {
    staticClass: "C817"
  }, [_vm._v("Katharine G. Abraham (chair)")]), _vm._v(" "), _c('p', {
    staticClass: "C817"
  }, [_vm._v("John M. Abowd")]), _vm._v(" "), _c('p', {
    staticClass: "C817"
  }, [_vm._v("Susanto Basu")]), _vm._v(" "), _c('p', {
    staticClass: "C817"
  }, [_vm._v("Ernst R. Berndt")]), _vm._v(" "), _c('p', {
    staticClass: "C817"
  }, [_vm._v("Alberto Cavallo")]), _vm._v(" "), _c('p', {
    staticClass: "C817"
  }, [_vm._v("Carol A. Corrado")]), _vm._v(" "), _c('p', {
    staticClass: "C817"
  }, [_vm._v("Lucy Eldridge")]), _vm._v(" "), _c('p', {
    staticClass: "C817"
  }, [_vm._v("John C. Haltiwanger")]), _vm._v(" "), _c('p', {
    staticClass: "C817"
  }, [_vm._v("Ron S. Jarmin")]), _vm._v(" "), _c('p', {
    staticClass: "C817"
  }, [_vm._v("J. Bradford Jensen")]), _vm._v(" "), _c('p', {
    staticClass: "C817"
  }, [_vm._v("Barry Johnson")]), _vm._v(" "), _c('p', {
    staticClass: "C817"
  }, [_vm._v("Greg Peterson")]), _vm._v(" "), _c('p', {
    staticClass: "C817"
  }, [_vm._v("Valerie A. Ramey")]), _vm._v(" "), _c('p', {
    staticClass: "C817"
  }, [_vm._v("Peter K. Schott")]), _vm._v(" "), _c('p', {
    staticClass: "C817"
  }, [_vm._v("Daniel E. Sichel")]), _vm._v(" "), _c('p', {
    staticClass: "C817"
  }, [_vm._v("Erich H. Strassner")]), _vm._v(" "), _c('p', {
    staticClass: "C817"
  }, [_vm._v("William Wascher")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-99fc43ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/07_Prefatory_Note.vue
// module id = 75
// module chunks = 0